import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "vault_booking_mode";

// Plan B safety net: if the GoHighLevel funnel is unreachable (or the shop flips
// the kill switch in the portal), every Book button points at our own /book page.
export const useBookingMode = () => {
  const [effective, setEffective] = useState(
    () => sessionStorage.getItem(CACHE_KEY) || "ghl",
  );

  useEffect(() => {
    let alive = true;
    fetch(`${API}/booking/mode`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive || !d) return;
        sessionStorage.setItem(CACHE_KEY, d.effective);
        setEffective(d.effective);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const direct = effective === "direct";

  return {
    direct,
    bookHref: (loc) => (direct ? `/book?shop=${loc.id}` : loc.booking),
    bookProps: (loc) =>
      direct
        ? { href: `/book?shop=${loc.id}` }
        : {
            href: loc.booking,
            target: "_blank",
            rel: "noopener noreferrer",
          },
  };
};
